import { useState } from "react";
import bgImage from "../assets/bg2.jpg";
import SearchByName from "../components/SearchByName";
import SearchByAddress from "../components/SearchByAddress";

export const BUILDING_TYPES = [
  "All", // special option to return all
  "Detached", // includes Detached, House, Single Family, Bungalow, Link
  "Semi-Detached", // includes Semi-Detached
  "Townhouse", // includes all Att/Row/Townhouse variants, Condo Townhouse
  "Condo", // includes Condo Apartment, Condo Apt, Condominiums, Leasehold Condo, Common Element Condo, Comm Element Condo
  "Co-op Apartment", // includes Co-op Apartment, Co-op Apt, Co-Ownership Apartment, Co-ownership Apt
  "Multiplex", // includes Duplex, Triplex, Fourplex, Multiplex
  // "Other",            // includes Parking, Locker, Vacant land, Store W/Apt/Office, Other
];

export default function SearchPage() {
  const [searchMode, setSearchMode] = useState("name");
  const [search, setSearch] = useState("");
  const [buildingType, setBuildingType] = useState("All");

  const handleModeChange = (mode) => {
    setSearchMode(mode);
    setSearch(""); // reset search input
    setBuildingType("All"); // reset building type
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-start w-full min-h-screen relative">
      {/* Background */}
      <div
        className="fixed inset-0 z-0 bg-cover bg-top bg-no-repeat"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
      <div className="fixed inset-0 bg-black/30 z-0" />

      {/* Content */}
      <div className="relative z-10 max-w-6xl w-full mx-auto p-6 md:p-12 flex flex-col items-center gap-6">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-100 text-center mb-6">
          Who would be the best brokerage for you?
        </h2>

        {/* Controls: radio + dropdown */}
        <div className="flex flex-col md:flex-row gap-4 items-center mb-6">
          <div className="flex gap-6">
            <label className="flex items-center gap-2 text-white cursor-pointer">
              <input
                type="radio"
                name="searchMode"
                value="name"
                checked={searchMode === "name"}
                onChange={() => handleModeChange("name")}
                className="appearance-none w-4 h-4 border-2 border-white rounded-full checked:bg-white checked:border-white cursor-pointer"
              />
              Search by Name
            </label>
            <label className="flex items-center gap-2 text-white cursor-pointer">
              <input
                type="radio"
                name="searchMode"
                value="address"
                checked={searchMode === "address"}
                onChange={() => handleModeChange("address")}
                className="appearance-none w-4 h-4 border-2 border-white rounded-full checked:bg-white checked:border-white cursor-pointer"
              />
              Search by Address
            </label>
          </div>

          {/* Building Type Dropdown */}
          <select
            value={buildingType}
            onChange={(e) => setBuildingType(e.target.value)}
            className="ml-0 md:ml-6 px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white text-gray-900"
          >
            {BUILDING_TYPES.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Conditional Search Components */}
        {searchMode === "name" ? (
          <SearchByName
            search={search}
            setSearch={setSearch}
            buildingType={buildingType}
          />
        ) : (
          <SearchByAddress
            search={search}
            setSearch={setSearch}
            buildingType={buildingType}
          />
        )}
      </div>
    </div>
  );
}
